import { LocalizedText } from "../LocalizedText";
import './ContextMenu.scss';
import * as React from 'react';
import { createPortal } from 'react-dom';
import { isMobileGameDevice } from '../../hooks/useMobileGameViewport';
import { Position } from '../../interfaces';
import SmallBG2 from '../../assets/UIResource/Common/SmallBG2.png';

interface Props {
  position: Position;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export function ContextMenu({ position, style, children }: Props) {
  const mobile = isMobileGameDevice();
  const ref = React.useRef<HTMLDivElement>(null);
  const [point, setPoint] = React.useState(position);
  React.useLayoutEffect(()=>{
    if(!mobile || !ref.current)return;
    const box=ref.current.getBoundingClientRect();
    setPoint({x:Math.max(4,Math.min(position.x,window.innerWidth-box.width-4)),y:Math.max(4,Math.min(position.y,window.innerHeight-box.height-4))});
  },[position.x,position.y,mobile]);
  const imageStyle: React.CSSProperties = {
    borderWidth: '5px',
    borderStyle: 'solid',
    borderImage: `url(${SmallBG2}) 5 fill`,
  };

  const menu = (
    <div ref={ref} id="context-menu" style={{ ...imageStyle, ...style, ...(mobile?{zIndex:2147483640}:{}), position: 'fixed', top: mobile?point.y:position.y, left: mobile?point.x:position.x }}>
      {children}
    </div>
  );
  return mobile ? createPortal(menu,document.body) : menu;
}

function Item({ onClick, title, disabled = false }: { onClick: (e: React.MouseEvent) => void; title: string; disabled?: boolean }) {
  return (
    <div
      className={'context-menu__item ' + `${disabled ? 'disabled' : ''}`}
      role="button"
      tabIndex={disabled?-1:0}
      aria-disabled={disabled}
      onClick={(e) => {
        if (disabled) {
          return;
        }
        onClick(e);
      }}>
      <LocalizedText text={title} />
    </div>
  );
}

ContextMenu.Item = Item;
